import $ from 'jquery';

function footerAccordion() {
	let mobile 				= window.matchMedia('(max-width: 768px)').matches, 
			$widgetTitle 	= $('.c-footer_accordion .widgettitle');

	// Check if mobile
	if( !mobile ) return;

	// Add aira hidden attr to accordion content
	$widgetTitle.siblings('div').attr('aria-hidden', true);

	$widgetTitle.click(function() {
		let $accordionContent = $(this).siblings('div');

		// Toggle open and slide
		$(this).toggleClass('is-open');
		$accordionContent.slideToggle();

		// Toggle aria hidden
		$accordionContent.attr('aria-hidden', $accordionContent.attr('aria-hidden') === 'true' ? 'false' : 'true' );
	});
}

export { footerAccordion };